import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class PreloaderResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("PreloaderResourcesPackage");
    }
    public get assets_preloader_DelaGothicOne_Regular_ttf(): FontFace {
        return this.resource<FontFace>("assets/preloader/DelaGothicOne-Regular.ttf");
    }
    public get assets_preloader_background_png(): Texture {
        return this.resource<Texture>("assets/preloader/background.png");
    }
    public get assets_preloader_background_mobile_png(): Texture {
        return this.resource<Texture>("assets/preloader/background_mobile.png");
    }
    public get assets_preloader_field_png(): Texture {
        return this.resource<Texture>("assets/preloader/field.png");
    }
    public get assets_preloader_fill_png(): Texture {
        return this.resource<Texture>("assets/preloader/fill.png");
    }
    public get assets_preloader_logo_png(): Texture {
        return this.resource<Texture>("assets/preloader/logo.png");
    }
    public get assets_preloader_progress_progres_atlas(): any {
        return this.resource<any>("assets/preloader/progress/progres.atlas");
    }
    public get assets_preloader_progress_progres_json(): Object {
        return this.resource<Object>("assets/preloader/progress/progres.json");
    }
    public get assets_preloader_progress_progres_png(): Texture {
        return this.resource<Texture>("assets/preloader/progress/progres.png");
    }
}

